import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=634d1d17"
import script from "./privacy-policy.vue?vue&type=script&lang=js"
export * from "./privacy-policy.vue?vue&type=script&lang=js"
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=634d1d17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports